/* eslint-disable no-unused-vars */
export enum LoadingTypes {
  idle = 'idle',
  pending = 'pending',
  fulfilled = 'fulfilled',
  rejected = 'rejected',
}